export const calculateFees = ({paymentAmount, offer}) => {
  const feeAmount = paymentAmount.multiply(offer.pointsFeeRate)
  const taxAmount = feeAmount.multiply(offer.taxRate)
  const totalFeeAmount = feeAmount.add(taxAmount)
  const totalAmount = paymentAmount.add(totalFeeAmount)

  return {
    feeAmount,
    taxAmount,
    totalFeeAmount,
    totalAmount,
  }
}
